<template>
  <el-dialog width="35%"
             v-dialog-drag
             title="预约备注"
             :before-close="handleClickCancel"
             :close-on-press-escape="false"
             :close-on-click-modal="false"
             :visible.sync="remarkVisible">
    <el-form size="small"
             ref="remarkForm"
             label-position="top"
             label-width="85px"
             :model="remarkForm"
             :rules="remarkFormRules" v-loading="loading">
      <el-form-item label="" prop="">
        <el-input  ref="copyInput" placeholder="请输入预约备注" type="textarea" :rows="4"  v-model="remarkForm.remark"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button size="small"   :disabled="btnDisabled" @click="handleClickCancel">取消</el-button>
      <el-button size="small"   :disabled="btnDisabled" @click="handleClickConfirm" type="primary">确定</el-button>
    </div>
  </el-dialog>
</template>
<script>

import { appointEdit } from '@/api'

export default {
  name: 'remark',
  props: {
    remarkVisible: {
      type: Boolean,
      default: false,
    },
    appointId: {
      type: Number,
      default: 0,
    },
    remark: {
      type: String,
      default: '',
    }

  },
  data () {
    return {
      remarkForm: {
        remark:'',
        appoint_id:'',
      },
      remarkFormRules: { },
      loading: false,
      btnDisabled:false
    }
  },
  created () {
  },
  mounted () {
    if(this.remark){
      this.remarkForm.remark = this.remark
    }
    this.remarkForm.appoint_id = this.appointId

  },
  methods: {
    //取消事件
    handleClickCancel () {
      //重置表格
      this.$refs.remarkForm.resetFields()
      this.btnDisabled = false
      //关闭对话框
      this.$emit('update:remarkVisible', false)
    },
    handleClickConfirm(){
      this.$refs.remarkForm.validate(valid => {
        if (valid) {
          this.btnDisabled = true
          appointEdit({
            remark: this.remarkForm.remark,
            appoint_id: this.remarkForm.appoint_id,
          }).then(res => {
            if (res.code === 200) {
              // 验证通过调用新增菜单接口
              this.$message.success('编辑成功')
              //调用取消事件
              this.handleClickCancel()
              //父页面刷新列表
              this.$emit('success')
            }else{
              this.btnDisabled = false
              this.$message.error(res.message)
            }
          })
        } else {
          return false
        }
      })
    },

  },

}
</script>
<style lang="scss" scoped>
.hintTitle {
  font-size: 14px;
  line-height: 36px;
  color: #000;
  margin-top: 5px;
}

.upload_img_wrap {
  width: 148px;
  height: 148px;
}

.upload_img_wrap img {
  width: 146px;
  height: 146px;
}
.el-form{
  margin-top: 10px;
}
</style>
